import React, { useState } from 'react';
import { Menu, MenuItem, ListItemIcon, ListItemText, Box, styled } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';

const StyledGridActionsCellItem = styled(GridActionsCellItem)({
    '& .MuiButtonBase-root': {
        justifyContent: 'space-between',
        width: '100%',
    },
    '& .MuiSvgIcon-root': {
        marginLeft: 'auto',
    }
});

const Submenu = ({ label, items, showInMenu = true }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event) => {
        event?.stopPropagation();
        setAnchorEl(null);
    };

    return (
        <>
            <StyledGridActionsCellItem
                label={
                    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        {label}
                        <ChevronRightRoundedIcon fontSize="small" />
                    </Box>
                }
                onClick={handleClick}
                showInMenu={showInMenu}
            />
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                {items.map((item, index) => (
                    <MenuItem
                        key={index}
                        onClick={(event) => {
                            event.stopPropagation();
                            item.onClick();
                            handleClose();
                        }}
                    >
                        <ListItemIcon>{item.icon}</ListItemIcon>
                        <ListItemText>{item.label}</ListItemText>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default Submenu; 